import React from 'react';
import PasswordResetForm from "../../components/Login/PasswordResetForm";
import styles from '../../components/Layout/LayoutOut.module.css';
import LayoutOut from "../../components/Layout/LayoutOut";
import logo from '../../assets/images/elanciaatwork.png';
import {Link, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong} from "@fortawesome/free-solid-svg-icons";
import Routing from "../../services/routing";

function PasswordResetPage() {
    const navigate = useNavigate();

    return (
        <LayoutOut>
            <a className={styles.backLink} onClick={() => {
                navigate(-1)
            }}>
                <FontAwesomeIcon icon={faArrowLeftLong} className={styles.chevron}/>
                Retour
            </a>

            <Link to={Routing.routes.login}><img className={styles.logo} alt="elancia" src={logo}/></Link>
            <PasswordResetForm/>
            <button className={`btn ${styles.btnBack}`}  onClick={() => {
                navigate(-1)
            }}>
                Annuler
            </button>
        </LayoutOut>
    );
}

export default PasswordResetPage;
